module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-up-0.33356bcb.svg";